import { render, staticRenderFns } from "./products-bulk-panel.vue?vue&type=template&id=23ba1922"
import script from "./products-bulk-panel.vue?vue&type=script&lang=js"
export * from "./products-bulk-panel.vue?vue&type=script&lang=js"
import style0 from "./products-bulk-panel.vue?vue&type=style&index=0&id=23ba1922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports